import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../../constants';

export const paperStyles: SxProps<Theme> = {
	width: '250px',
	marginTop: '10px',
	borderRadius: '8px',
	backgroundColor: Colors['101010'],
	border: `1px solid ${Colors['2A2A2A']}`,

	'& .MuiList-root': {
		padding: 0,
	},
};

export const currentUserStyles: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	columnGap: '10px',
	p: '16px',
	backgroundColor: Colors['161616'],
	border: `1px solid ${Colors['2A2A2A']}`,
};

export const currentUserLabelStyles: SxProps<Theme> = {
	fontFamily: 'Montserrat, sans-serif',
	fontSize: '10px',
	fontWeight: 500,
	lineHeight: '100%',
	textTransform: 'uppercase',
	color: Colors.white_a50,
};

export const currentUserNameStyles: SxProps<Theme> = {
	fontFamily: 'Montserrat, sans-serif',
	fontSize: '13px',
	fontWeight: 600,
	lineHeight: '21px',
	color: Colors.white,
};

export const menuItemStyles: SxProps<Theme> = {
	columnGap: '10px',
	display: 'flex',
	alignItems: 'center',
	padding: '10.5px 16px',
	borderBottom: `1px solid ${Colors.white_a5}`,
	fontFamily: 'Montserrat, sans-serif',
	fontWeight: 600,
	fontSize: '14px',
	lineHeight: '124%',
	color: Colors.white,

	'&:hover': {
		backgroundColor: Colors['2A2A2A'],
	},

	'& >svg': {
		width: '24px',
		height: '24px',
	},

	'&:last-of-type': {
		borderBottomWidth: 0,
	},
};

export const newFeatureLabelStyles: SxProps<Theme> = {
	position: 'relative',
	fontFamily: 'Hind, sans-serif',
	fontWeight: 700,
	fontSize: '12px',
	lineHeight: '16px',
	color: Colors.white,
	borderRadius: '16px',
	p: '4px 8px 1px 8px',
	textTransform: 'uppercase',
	boxShadow: `
		-13px 4px 24px 0px #F93F101A,
		10.01px 4px 24px 0px #79CD491A,
		12px 4px 24px -11px #6835E466
	`,
	border: '1px solid transparent',

	'&:before': {
		content: '""',
		position: 'absolute',
		inset: 0,
		borderRadius: '16px',
		padding: '1.1px',
		background:
			'linear-gradient(83.46deg, #F13939 -36.64%, #FFE23F -16.44%, #3DCA66 16.78%, #3CCFBA 43.93%, #B292E7 71.38%, #EE4C9A 101%, #8A6AD4 127.36%)',
		mask: `linear-gradient(${Colors['101010']} 0 0) content-box, linear-gradient(${Colors['101010']} 0 0)`,
		maskComposite: 'exclude',
	},
};
